
import logoImage from "./51logo.png"


function Logo(){
    return(
     <img src={logoImage} alt="logo" width={200} />
    )
}

export default Logo